import { useCallback, useContext, useRef } from 'react';

import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component';
import { EDIT_PAGE_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName';
import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive';
import { useIsLivePagesFeatureEnabled } from '@confluence/live-pages-utils/entry-points/useIsLivePagesFeatureEnabled';

export const useLivePageEditExperience = ({ contentId }: { contentId: string }) => {
	const wasStartedRef = useRef<boolean>(false);
	const experienceTracker = useContext(ExperienceTrackerContext);
	const isLivePage = useIsCurrentPageLive();
	const { livePageReleasePhase } = useIsLivePagesFeatureEnabled();

	return useCallback(() => {
		if (!wasStartedRef.current && isLivePage) {
			experienceTracker.start({
				name: EDIT_PAGE_EXPERIENCE,
				attributes: {
					contentId,
					isLivePage,
					livePageReleasePhase,
				},
			});
			wasStartedRef.current = true;
		}
	}, [wasStartedRef, experienceTracker, isLivePage, contentId, livePageReleasePhase]);
};
